import script from "./ModalRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalRecords.vue?vue&type=script&setup=true&lang=js"

import "./ModalRecords.vue?vue&type=style&index=0&id=2f434f6a&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f434f6a"]])

export default __exports__